// extracted by mini-css-extract-plugin
export var addViewLink = "_5-2";
export var availabilityIcon = "_5-17";
export var availabilitySelectionIcon = "_5-16";
export var backButton = "_5-3";
export var backIcon = "_5-10";
export var conversationCount = "_5-4";
export var dragHandle = "_5-6";
export var dropdown = "_5-f";
export var dropdownIcon = "_5-8";
export var dropdownOption = "_5-7";
export var dropdownTriangle = "_5-e";
export var expand = "_5-g";
export var folder = "_5-j";
export var folderItem = "_5-d";
export var icon = "_5-9";
export var iconRow = "_5-a";
export var image = "_5-b";
export var logo = "_5-c";
export var navContainer = "_5-i";
export var navigationFooter = "_5-h";
export var pageShell = "_5-0";
export var pageShellWms = "_5-1";
export var placeholderAvailable = "_5-12";
export var placeholderBox = "_5-15";
export var placeholderBusy = "_5-14";
export var placeholderUnavailable = "_5-13";
export var profile = "_5-l";
export var profileContainer = "_5-n";
export var profileDropdown = "_5-o";
export var profileImage = "_5-m";
export var profileMain = "_5-p";
export var profileSubtitle = "_5-r";
export var profileTitle = "_5-q";
export var reorderIcon = "_5-s";
export var sentLine = "_5-v";
export var settingsHeader = "_5-t";
export var sidenavTextColor = "_5-z";
export var spamLine = "_5-u";
export var subitemWithTag = "_5-5";
export var supportItems = "_5-k";
export var teamText = "_5-11";
export var viewLine = "_5-y";
export var viewLineButton = "_5-x";
export var viewLineButtons = "_5-w";